import { CSSProperties, ReactNode } from 'react';

import {
	Button,
	Flex,
	Modal,
	ModalProps,
	Stack,
	StyleProp,
	TextInput,
	TextInputProps,
} from '@mantine/core';

import IconSearch from '@/shared/uikit/assets/icons/IconSearch.svg?react';

import { CustomButtonProps } from '../../types';

import classes from './ModalSheet.module.css';

type ModalSheetProps = {
	buttons?: CustomButtonProps[];
	buttonsWidget?: ReactNode;
	buttonsDirection?: StyleProp<CSSProperties['flexDirection']>;
	search?: TextInputProps;
} & ModalProps;

export const ModalSheet = ({
	children,
	buttons,
	buttonsWidget,
	buttonsDirection,
	search,
	...rest
}: ModalSheetProps) => {
	return (
		<Modal classNames={classes} {...rest}>
			<Stack>
				{search && (
					<TextInput
						placeholder="Поиск"
						size="sm"
						w="100%"
						radius="13px"
						leftSection={<IconSearch width={20} />}
						{...search}
					/>
				)}
				{children}
				{buttons && (
					<Flex direction={buttonsDirection} gap="md">
						{buttonsWidget}
						{buttons?.map((el, index) => (
							<Button {...el} size="lg" fullWidth key={index}>
								{el.children}
							</Button>
						))}
					</Flex>
				)}
			</Stack>
		</Modal>
	);
};
